import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { BsSearch } from "react-icons/bs";
import { ImCross } from "react-icons/im";
import provinces from "@doncicuto/es-provinces";
import municipalities from "@doncicuto/es-municipalities";
import { listCommercials, listTecnicos, listCosultor, getConsultores } from "../../services";
import {
  cambiarFormatoNombre,
  municipiosIniciales,
} from "../../functions/funciones";
import { ordenarNombreYApellido, orderArray, ordenarProvinciasYMunicipios } from '../../functions/ordenarListas';
import { UsuarioContext } from "../../providers/userContext";
import {
  Box,
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import SearchProgresState from "./SearchProgresState";
import { useLocation } from "react-router-dom";

const formContainerStyles = css`
  height: 19px !important; 
`;

const FormContainer = styled("div")`
  ${formContainerStyles}
`;
const FiltrosAAFF = ({ onFilter, consultorOculto, comercialOculto, clearFilter, filtrosIniciales }) => {
  const { t } = useTranslation('common');

  const user = useContext(UsuarioContext);
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [comercial, setComercial] = useState([]);
  const [consultor, setConsultor] = useState([]);
  const [tecnico, setTecnico] = useState([]);
  const [listadoMunicipios, setListadoMunicipios] = useState([]);
  const [value, setValue] = useState(null);
  const [sinConsul, setSinConsul] = useState(false);
  const [sinTech, setSinTech] = useState(false);
  const coordinadorPrecargado = useRef(false);

  const location = useLocation();
  useEffect(() => {
    getDatas();
  }, []);

  useEffect(() => {
    setListadoMunicipios(
      municipiosIniciales(provinces, municipalities, busqueda.provincia)
    );
  }, [busqueda]);

  useEffect(() => {
    cargarUser();
  }, []);
  
  // El coordinador arranca viendo solo sus AAFF; si vacia el filtro vera los de todo su equipo
  const aplicarTecnicoCoordinador = (filtrosBase = {}) => {
    setTecnico([{ id: user.id, nombre: user.nombre, apellidos: user.apellidos }]);
    const filtros = { ...filtrosBase, tech_id: user.id };
    setBusqueda(filtros);
    onFilter(filtros);
  };

  const cargarUser = () => {
    if (user.rol === "TECH_COOR" && sinTech === false && user.nombre) {
      // Solo en la carga inicial y respetando un tecnico que ya venga en los filtros de la URL
      if (!coordinadorPrecargado.current) {
        coordinadorPrecargado.current = true;
        if (busqueda?.tech_id === undefined) {
          aplicarTecnicoCoordinador(busqueda);
        }
      }
    } else if (user.rol === "CONSUL" && sinConsul == false) {
      setBusqueda({
        ...busqueda,
        consul_id: user.id
      });

    }
    localStorage.setItem("hasReloaded", "false");
  };

  useEffect(() => {
    if (localStorage.getItem("hasReloaded") === "true") {
      clearAllFilters();
      cargarUser();
      localStorage.setItem("hasReloaded", "false");

    }

  }, [location]);

  const clearAllFilters = () => {
    setBusqueda('');
    setSinConsul(false);
    setSinTech(false);
    clearFilter();
    if (user.rol === "TECH_COOR" && user.nombre) {
      coordinadorPrecargado.current = true;
      aplicarTecnicoCoordinador();
      localStorage.setItem("hasReloaded", "false");
    } else {
      cargarUser();
    }

  };

  const getDatas = async () => {

    const consul =
      user.rol === "CONSUL"
        ? await getConsultores({ filtros: { id: user.id } })
        : [];


    if (user.rol === "CONSUL" && consul.data?.length > 0 && !consultorOculto) {
      setBusqueda({
        ...busqueda,
        consul_id: user.id,
      });

      setConsultor(ordenarNombreYApellido(consul.data));
    }

  };

  const seleccionarMunicipios = (e) => {
    let codProvincia = "";
    let municipios = [];
    provinces.map((p) => {
      if (p.name === e.target.value) {
        codProvincia = p.code;
      }
    });
    if (e.target.name === "provincia" || e.target.value === "") {
      setBusqueda({
        ...busqueda,
        [e.target.name]: e.target.value,
        municipio: "", // Establecer el campo municipio en vacío
      });
    } else {
      setBusqueda({
        ...busqueda,
        [e.target.name]: e.target.value,
      });
    }
    municipalities.map((m) => {
      if (m.provCode === codProvincia) {
        municipios.push({
          ...m,
          name: cambiarFormatoNombre(m.name),
          value: m.name,
        });
      }
    });
    setListadoMunicipios(municipios);
  };

  const handleAsynchronousChange = (name, selectedValue) => {
    setBusqueda({
      ...busqueda,
      [name]: selectedValue?.id,
    });
  };

  const busquedaInput = (name, valorBusqueda) => {
    if (name === 'commer_id' && (busqueda.commer_id !== undefined || valorBusqueda) && !comercialOculto) {

      listCommercials({
        filtros: {
          nombreA: valorBusqueda
        }, params: {}
      }).then(res => {
        setComercial(ordenarNombreYApellido(res.data))
      });
    }

    if (name === 'tech_id' && (busqueda.tech_id !== undefined || valorBusqueda)) {

      listTecnicos({
        filtros: {
          nombreA: valorBusqueda,
          ...(user.rol === "TECH_COOR" && { team_id: user.equipo })
        }, params: {}
      }).then(res => {
        setTecnico(ordenarNombreYApellido(res.data))
      });
    }


    if (name === 'consul_id' && (busqueda.consul_id !== undefined || valorBusqueda)) {

      listCosultor({
        filtros: {
          nombreA: valorBusqueda
        }, params: {}
      }).then(res => {
        setConsultor(ordenarNombreYApellido(res.data))
      });
    }

  };

  function handleChange(evt) {
    const value = evt.target.value;

    setBusqueda({
      ...busqueda,
      [evt.target.name]: value,
    });
  }

  function handleBooleanChange(evt) {
    const value = evt.target.value;
    const boolValue = value === "" ? undefined : value === "true" || value === true;
    setBusqueda({
      ...busqueda,
      [evt.target.name]: boolValue,
    });
  }

  const getBusqueda = () => {
    for (let key in busqueda) {
      if (typeof busqueda[key] === 'boolean') {
        continue;
      }
      if (
        busqueda[key] === "" ||
        busqueda[key] === null ||
        busqueda[key] === undefined
      ) {
        delete busqueda[key];
      }
    }
    if (busqueda.consul_id == undefined) {
      setSinConsul(true);
    }
    if (busqueda.tech_id == undefined) {
      setSinTech(true);
    }
    onFilter(busqueda);
  };

  return (
    <>
      {user.rol === "AAFF" && user.nombre ?
        <></>
        :
        <>
          <div className="buscadorFiltros">
            <div style={{ width: "100%" }}>
              <Box mx={1} display={"block"} flexDirection={"row"} gap={2}>
                <TextField
                  id="razonSocial-input"
                  label={t('filters.businessName')}
                  variant="outlined"
                  name="razonSocial"
                  className="filtros altura"
                  value={busqueda.razonSocial ?? ""}
                  onChange={handleChange}
                  onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                  inputProps={{
                    "aria-label": "controlled",
                  }}
                />
                <TextField
                  id="nif-input"
                  label={t('filters.nif')}
                  variant="outlined"
                  name="nif"
                  className="filtros altura"
                  value={busqueda.nif ?? ""}
                  onChange={handleChange}
                  onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                  inputProps={{
                    "aria-label": "controlled",
                  }}
                />
                <TextField
                  id="email-input"
                  label={t('filters.email')}
                  variant="outlined"
                  name="emailContacto"
                  className="filtros altura"
                  value={busqueda.emailContacto || ""}
                  onChange={handleChange}
                  onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                  inputProps={{
                    "aria-label": "controlled",
                  }}
                />
                <TextField
                  id="telefono-input"
                  label={t('filters.phone')}
                  variant="outlined"
                  name="telefono"
                  className="filtros altura"
                  value={busqueda.telefono || ""}
                  onChange={handleChange}
                  onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
                  inputProps={{
                    "aria-label": "controlled",
                  }}
                />

                {user.rol === "SUPP" ? null : (
                  <>
                    <FormControl variant="outlined" className="filtros-select">
                      <InputLabel id="provincia-label">{t('filters.province')}</InputLabel>
                      <Select
                        labelId="comunidad-label"
                        id="province-select"
                        label={t('filters.province')}
                        name="provincia"
                        className="filtros"
                        value={busqueda.provincia || ""}
                        onChange={seleccionarMunicipios}
                        onKeyPress={(e) =>
                          e.key === "Enter" ? getBusqueda() : ""
                        }
                      >
                        <MenuItem value="" style={{ height: 40 }}></MenuItem>
                        {provinces
                          .sort(ordenarProvinciasYMunicipios)
                          ?.map((e, i) => {
                            return (
                              <MenuItem key={i} value={e.name}>
                                {e.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                    <FormControl variant="outlined" className="filtros-select">
                      <InputLabel id="municipio-label">{t('filters.municipalities')}</InputLabel>
                      <Select
                        labelId="municipio-label"
                        id="municipio-select"
                        label={t('filters.municipality')}
                        name="municipio"
                        className="filtros"
                        value={busqueda?.municipio || ""}
                        onChange={handleChange}
                        onKeyPress={(e) =>
                          e.key === "Enter" ? getBusqueda() : ""
                        }
                      >
                        <MenuItem value="" style={{ height: 40 }}></MenuItem>
                        {listadoMunicipios
                          .sort(ordenarProvinciasYMunicipios)
                          ?.map((e, i) => {
                            return (
                              <MenuItem key={i} value={e.name}>
                                {e.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </>
                )}

                {user.rol === "TECH_COOR" && (
                  <FormControl variant="outlined" className="filtros-select">
                    <SearchProgresState
                      labelId="tecnico-label"
                      id="tecnico-select"
                      label={t('filters.technician')}
                      name="tech_id"
                      className="filtros"
                      tipo="nombre"
                      array={tecnico}
                      onOptionSelected={handleAsynchronousChange}
                      busquedaInput={busquedaInput}
                      valueOnLoad={tecnico.find(c => c.id === busqueda.tech_id)}
                    />
                  </FormControl>
                )}

                {user.rol === "TECH" || user.rol === "TECH_COOR" || user.rol === "SUPP" || user.rol === "COMM" || user.rol === "ADMIN_CAI" ? null : (
                  <>
                    {comercialOculto ? null : (
                      <FormControl variant="outlined" className="filtros-select">
                        <SearchProgresState
                          labelId="comercial-label"
                          id="comercial-select"
                          label={t('filters.commercial')}
                          name="commer_id"
                          className="filtros"
                          tipo="nombre"
                          array={comercial}
                          onOptionSelected={handleAsynchronousChange}
                          busquedaInput={busquedaInput}
                          valueOnLoad={comercial.find(c => c.id === busqueda.commer_id)}
                        />
                      </FormControl>
                    )}

                    <FormControl variant="outlined" className="filtros-select">
                      <SearchProgresState
                        labelId="tecnico-label"
                        id="tecnico-select"
                        label={t('filters.technician')}
                        name="tech_id"
                        className="filtros"
                        tipo="nombre"
                        array={tecnico}
                        onOptionSelected={handleAsynchronousChange}
                        busquedaInput={busquedaInput}
                        valueOnLoad={tecnico.find(c => c.id === busqueda.tech_id)}
                        staticOptions={[{ id: 'sinTecnico', nombre: 'Sin Técnico', apellidos: 'asignado' }]}
                      />
                    </FormControl>
                  </>
                )}
                {user.rol === "TECH" || user.rol === "TECH_COOR" || user.rol === "SUPP" || user.rol === "ADMIN_CAI" ? null : (
                  <>  
                    {consultorOculto ? null : (
                      <FormControl variant="outlined" className="filtros-select">
                        <SearchProgresState
                          labelId="consultor-label"
                          id="consultor-select"
                          label={t('filters.consultant')}
                          name="consul_id"
                          className="filtros"
                          tipo="nombre"
                          array={consultor}
                          onOptionSelected={handleAsynchronousChange}
                          busquedaInput={busquedaInput}
                          valueOnLoad={consultor.find(c => c.id === busqueda.consul_id)}
                        />
                      </FormControl>
                    )}
                  </>
                )}
                {user.rol === "TECH" || user.rol === "TECH_COOR" || user.rol === "SUPP" || user.rol === "COMM" || user.rol === "ADMIN_CAI" ? null : (
                  <>
                    <FormControl variant="outlined" className="filtros-select">
                      <InputLabel id="source-label">{t('filters.source')}</InputLabel>
                      <Select
                        labelId="source-label"
                        id="source-select"
                        label={t('filters.source')}
                        name="source"
                        className="filtros"
                        value={busqueda?.source || ""}
                        onChange={handleChange}
                        onKeyPress={(e) =>
                          e.key === "Enter" ? getBusqueda() : ""
                        }
                      >
                        <MenuItem value="" style={{ height: 40 }}></MenuItem>
                        <MenuItem value={"taaf"}>
                          {"taaf"}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </>


                )}
                {(user.rol === "ADMIN" || user.rol === "CONSUL" || user.rol === "VENT") && (
                  <FormControl variant="outlined" className="filtros-select">
                    <InputLabel id="hasPendingDocs-label">{t('filters.pendingDocsValidation')}</InputLabel>
                    <Select
                      labelId="hasPendingDocs-label"
                      id="hasPendingDocs-select"
                      label={t('filters.pendingDocsValidation')}
                      name="hasPendingDocs"
                      className="filtros"
                      value={busqueda?.hasPendingDocs !== undefined ? String(busqueda.hasPendingDocs) : ""}
                      onChange={handleBooleanChange}
                      onKeyPress={(e) =>
                        e.key === "Enter" ? getBusqueda() : ""
                      }
                    >
                      <MenuItem value="" style={{ height: 40 }}></MenuItem>
                      <MenuItem value="true">{t('filters.yes')}</MenuItem>
                      <MenuItem value="false">{t('filters.no')}</MenuItem>
                    </Select>
                  </FormControl>
                )}
              </Box>
            </div>
            <div>
              <Button className="btn-buscador" onClick={clearAllFilters}>
                <ImCross />
              </Button>
            </div>
            <div>
              <Button className="btn-buscador" onClick={() => getBusqueda()}>
                <BsSearch />
              </Button>
            </div>
          </div>
        </>
      }

      <style jsx="true">
        {`
          .btn-buscador {

            padding: 5px 10px;
            color: #ffffff;
            background-color: #92004d;
            border-radius: 4px;
            font-weight: bold;
            width: -moz-fit-content;
            width: fit-content;
            align-self: flex-end;
            border: none;
            min-width: 40px;
            height: 40px;
            margin: 5px 10px 5px;
          }
          .btn-buscador:hover {
            color: black;
            background-color: #dee2e6;
          }
        `}
      </style>
    </>
  );
};



export default FiltrosAAFF;
